var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.07 46.0853C125.07 46.0389 125.072 45.9928 125.072 45.9463C125.072 20.7235 104.78 0.276489 79.7492 0.276489C61.1901 0.276489 45.2391 11.5189 38.2303 27.6123C36.4524 27.3039 34.6255 27.1412 32.7604 27.1412C15.0915 27.1412 0.767822 41.5745 0.767822 59.3787C0.767822 77.1829 15.0915 91.6162 32.7604 91.6162H127.572C140.087 91.6162 150.233 81.3925 150.233 68.7811C150.233 56.1697 140.087 45.9463 127.572 45.9463C126.726 45.9463 125.892 45.9945 125.07 46.0853Z",
    fill: "url(#paint0_linear_225_19381)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_19381",
    x1: 75.5003,
    y1: 62.898,
    x2: 70.0856,
    y2: 23.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudRight);
export default __webpack_public_path__ + "static/media/cloud-right.00f31d67a44c81a7fa257acf129d2233.svg";
export { ForwardRef as ReactComponent };